function postJSON(url, body) {
    return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
}

export async function fetchBoard(onboardingId) {
    if (window.__BOARD_DATA__) {
        const data = window.__BOARD_DATA__;
        delete window.__BOARD_DATA__;
        return data;
    }

    const url = `/onboarding.php?id=${onboardingId}`;
    const response = await fetch(url);
    const jsonData = await response.json();

    if (!response.ok || jsonData.error) {
        if (response.status === 404 || jsonData.error === 'Onboarding not found') {
            throw new Error(jsonData.message || `Onboarding not found (ID: ${onboardingId})`);
        }
        throw new Error(jsonData.message || `HTTP error! status: ${response.status}`);
    }

    return jsonData;
}

export async function sendCompleteRegistration(email, fbc, eventId, eventSourceUrl) {
    try {
        const params = new URLSearchParams();
        if (email) params.set('email', email);
        if (fbc) params.set('fbc', fbc);
        if (eventId) params.set('eventId', eventId);
        if (eventSourceUrl) params.set('eventSourceUrl', eventSourceUrl);
        const url = `/facebook.sendCompleteRegistration.php?${params.toString()}`;
        await fetch(url);
    } catch (err) {
        console.error('sendCompleteRegistration error:', err);
    }
}

export async function sendFBInitiateCheckout(email, eventId, eventSourceUrl) {
    try {
        await postJSON('/facebook.sendInitiateCheckout.php', { email, eventId, eventSourceUrl });
    } catch (err) {
        console.error('sendFBInitiateCheckout error:', err);
    }
}

export async function sendFBPurchase(email, price, eventId, eventSourceUrl) {
    try {
        await postJSON('/facebook.sendPurchase.php', { email, price, eventId, eventSourceUrl });
    } catch (err) {
        console.error('sendFBPurchase error:', err);
    }
}

export function createStripeSubscription(params) {
    return postJSON('/stripe.createSubscription.php', params);
}

export function createStripeSubscriptionWallet(endpoint, params) {
    return postJSON(endpoint, params);
}

export async function createSolidgateIntent(body) {
    const res = await postJSON('/solidgate.createIntent.php', body);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
}

export async function buyPdf(email, onboardingID, paymentProvider) {
    const endpoint = paymentProvider === 'solidgate'
        ? '/solidgate.buyPdf.php'
        : '/stripe.buyPdf.php';

    const res = await postJSON(endpoint, { email, onboardingID });
    return res.json();
}

export async function getCountryCode() {
    try {
        const response = await fetch('/ip.php');
        const code = await response.text();
        if (code && code.length === 2) {
            return code.trim();
        }
    } catch (error) {
        console.error('Failed to fetch country code:', error);
    }
    return 'US';
}
